import { deepDefaults } from '@polleverywhere/core/lib/util.js'
import SlideSet from '@polleverywhere/slide-set'
import { bindings } from '../'
import { platform } from './platform'

export async function createSlideSet (activities = [], options = {}) {
  const [width, height] = await Promise.all([
    bindings.masterSlideWidth(),
    bindings.masterSlideHeight()
  ])

  options = deepDefaults(options, {
    urlOptions: {
      placeholderUrl: {
        aspectRatio: width / height
      }
    }
  })

  if (platform() === 'google') {
    // SlideSet now hides QR codes from placeholders by default. But for goog_presenter,
    // the QR code is the way we know which url to present. So we need to _not_ hide
    // QR codes for goog placeholders. We're clearing our hide param to that effect.
    options.urlOptions.placeholderUrl.hide = ''
  }

  return new SlideSet(activities, options)
}
